import ProductCell from './ProductCell';
import { wardsNavigate } from 'src/ui/wards/router/WardsScreenRegistration';
import { useNavigate } from 'react-router-dom';
import { WA_Screen } from 'src/ui/wards/router/WardsScreens';
import { WaScreensMap } from 'src/ui/wards/router/WardsScreenMap';
import { WaProduct } from 'src/api/wa/store/models/product/WaProduct';
import { useWaProductStore } from 'src/api/wa/store/WaProductStore';

type ProductListProps = {
  productMasterInfo: WaProduct[];
  products: WaProduct[];
};

export function ProductList({ productMasterInfo, products }: ProductListProps) {
  const navigate = useNavigate();
  const { setSelectedProduct } = useWaProductStore();

  return (
    <ul className="space-y-1 bg-white">
      {productMasterInfo.map((value) => (
        <ProductCell
          key={value.productNumber}
          product={value}
          onClick={() => {
            const productWithDisaster = products?.find(
              (p) => p.productNumber === value.productNumber
            );
            if (productWithDisaster) {
              value = productWithDisaster; // Use the product with disaster info if available
            }

            setSelectedProduct(value);
            wardsNavigate(navigate, WaScreensMap[WA_Screen.ProductDetails].path);
          }}
        />
      ))}
    </ul>
  );
}
